import { render } from "./ProductLightbox.vue?vue&type=template&id=24b10d81&scoped=true"
import script from "./ProductLightbox.vue?vue&type=script&lang=js"
export * from "./ProductLightbox.vue?vue&type=script&lang=js"

import "./ProductLightbox.vue?vue&type=style&index=0&id=24b10d81&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b10d81"]])

export default __exports__